import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionTitle = ({ eyebrow, title, desc, light = false, align = "left" }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <span className={`inline-flex items-center gap-2 text-xs font-medium tracking-[0.25em] uppercase ${light ? "text-pink-200" : "text-[#e6007e]"}`}>
        <span className="h-px w-8 bg-grad-pink inline-block" />
        {eyebrow}
      </span>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.1] ${light ? "text-white" : "text-[#1a1118]"}`}>{title}</h2>
    </Reveal>
    {desc && (
      <Reveal delay={0.2}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-pink-100/80" : "text-zinc-600"}`}>{desc}</p>
      </Reveal>
    )}
  </div>
);
